import { render } from "./ScatterPlot.vue?vue&type=template&id=754a5607"
import script from "./ScatterPlot.vue?vue&type=script&lang=js"
export * from "./ScatterPlot.vue?vue&type=script&lang=js"

import "./ScatterPlot.vue?vue&type=style&index=0&id=754a5607&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__